/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState } from 'react';
import { Nav } from '../../molecules';
import { Footer } from '../../atoms/footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faArrowUp } from '@fortawesome/free-solid-svg-icons';

interface AppProps {
  children: React.ReactNode;
  toggle?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const AppLayout: React.FC<AppProps> = ({ children, toggle, style, className }) => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Nav toggle={toggle}>
      <div className={`overflow-hidden ${className ?? ''}`} style={style}>
        {children}
      </div>
      <Footer />

      {/* 🟣 Floating Buttons Container */}
      <div className="fixed md:bottom-6 bottom-28 right-6 flex items-center gap-4 z-50">
        {/* 📧 Email Button (always visible) */}
        <a
          href="mailto:info@kir-int-consult.com"
          className="
            w-12 h-12 rounded-full flex items-center justify-center
            bg-[#00D4FF]/15 hover:bg-[#00D4FF]/25
            border border-[#00D4FF]/40 text-[#00D4FF]
            transition-all duration-300 hover:scale-110
            shadow-[0_0_15px_rgba(0,212,255,0.4)]
          "
          aria-label="Email Us"
        >
          <FontAwesomeIcon icon={faEnvelope} className="text-xl" />
        </a>

        {/* ⬆ Scroll to Top (only visible when scrolled) */}
        {showScroll && (
          <button
            onClick={scrollToTop}
            className="
              w-12 h-12 rounded-full flex items-center justify-center
              bg-[#00D4FF]/20 hover:bg-[#00D4FF]/30
              border border-[#00D4FF]/40 text-[#00D4FF]
              transition-all duration-300 hover:scale-110
              shadow-[0_0_20px_rgba(0,212,255,0.5)]
            "
            aria-label="Scroll to Top"
          >
            <FontAwesomeIcon icon={faArrowUp} className="text-xl" />
          </button>
        )}
      </div>
    </Nav>
  );
};
